import React, { useEffect, useState, useContext } from "react";
import { GlobalContext } from '../../../context/GlobalContext';
import { useTranslation } from 'react-i18next';

import { PROD } from '../../../Constants/index';

const win: any = window;
const serverURL = win['base_portal_url'];

const DeviceTNC = React.memo(() => {
    const { state, dispatch }: any = useContext(GlobalContext);
    const [htmlData, setHTMLData] = useState<any>(null);
    const { lang, promotionType, promotionApplied, deviceFlow, appliedInstallment, promoAmount, promoPeriod  } = state;

    const activeFlow = deviceFlow || sessionStorage.getItem('device-flow') || '';
    const wajidName = promotionApplied?.name ? promotionApplied?.name.replaceAll(' ', '+') : '';
    const promotionName = promotionType === 'Wajid' ? wajidName : promotionApplied?.name;
    const { t } = useTranslation();

    //"Device_Subsidy_3600" ---> Raqi
    //Wajid Extra Subsidy // Wajid+Extra+Subsidy

       useEffect(() => {
        const fetchTerms = async () => {
            try {
                dispatch({ type: "LOADER", payload: { loading: true } });
                let url = '';
                if (activeFlow === 'subsidy' &&  promotionName === 'Wajid') {
                    url = `${serverURL}/web/${lang}/devices/terms-and-conditions/subsidy/${promotionName}`;
                } else if(activeFlow === 'subsidy'){
                    url = win["env_variable"]?.toUpperCase() === PROD 
                            ? `${serverURL}/web/${lang}/devices/terms-and-conditions/subsidy/device-subsidy?amount=${promoAmount}&months=${promoPeriod}`
                            : `${serverURL}/wps/wcm/connect/${lang}/devices/terms-and-conditions/subsidy/device-subsidy?amount=${promoAmount}&months=${promoPeriod}`;
                } else {
                    url =
                        win["env_variable"]?.toUpperCase() === PROD
                            ? `${serverURL}/web/${lang}/devices/terms-and-conditions/installment`
                            : `${serverURL}/wps/wcm/connect/${lang}/devices/terms-and-conditions/installment?projectid=6baebf6d-faba-48a8-ae40-0d2066613800`;
                }
                const res = await fetch(url);
                const data = await res.text();
                setHTMLData(data);
                // Wait until React renders HTML
                requestAnimationFrame(() => {
                    const monthlyInstalment = document.getElementById('monthly_installment');
                    const upfrontPayment = document.getElementById('upfront_payment');
                    const totalPayment = document.getElementById('total_payment');

                    const amountElements = document.querySelectorAll<HTMLElement>('.amount');
                    const monthsElements = document.querySelectorAll<HTMLElement>('.months');

                    if (amountElements.length && promoAmount) {
                        amountElements.forEach(element => element.innerHTML = String(promoAmount));
                    }
                    if (monthsElements.length && promoPeriod) {
                       monthsElements.forEach(element => element.innerHTML = String(promoPeriod));
                    }
                    if (monthlyInstalment) {
                        monthlyInstalment.innerHTML =
                            appliedInstallment?.MonthlyCommitmentAmt ?? '';
                    }
                    if (upfrontPayment) {
                        upfrontPayment.innerHTML =
                            appliedInstallment?.PromotionCommitmentPeriod ?? '';
                    }
                    if (totalPayment) {
                        totalPayment.innerHTML = `${t("SAR")} ${appliedInstallment?.TotalDeviceInstallmentAmount ?? ''}`;
                    }
                });
            } finally {
                dispatch({ type: "LOADER", payload: { loading: false } });
            }
        };
        fetchTerms();
    }, []);

    return (
        <div
            className="DeviceTnC__Content"
            dangerouslySetInnerHTML={{ __html: htmlData || '' }}
        />
    );
});

export default DeviceTNC